/**
 * Footer gọn cho web app nội bộ — không dùng pattern website công khai.
 */
import { Box, Typography } from '@mui/material'

export default function AppFooter() {
  return (
    <Box
      component="footer"
      sx={{
        width: '100%',
        py: 1,
        px: 3,
        borderTop: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}
    >
      <Typography variant="caption" color="text.secondary">
        © TBS UEL E-court
      </Typography>
    </Box>
  )
}
